import { Component, Input, OnInit } from '@angular/core';
import { InventoryCartService } from '../../../services/inventory/inventory-cart.service';
import { API, GeoCullDTO, InventoryFilterDTO, InventoryGeoAggregationFrontendEnhancedDTO, PlayerCullDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { ToasterService, ToastType } from '../../../services/toaster/toaster.service';
import { TranslateService } from '@ngx-translate/core';

export interface InventoryFilterDTOWithScreens extends InventoryFilterDTO {
  screens?: number[];
}

@Component({
  selector: 'sb-page-inventory-wrapper',
  templateUrl: './inventory-wrapper.component.html',
  styleUrls: ['./inventory-wrapper.component.scss'],
  standalone: false,
})
export class InventoryWrapperComponent implements OnInit {
  constructor(
    private inventoryService: InventoryCartService,
    private api: API,
    private errorHandler: ErrorService,
    private toaster: ToasterService,
    private translate: TranslateService
  ) {}

  @Input() isInModalContext: boolean;
  @Input() isInIntegratedContext: boolean;
  point;
  filter: InventoryFilterDTO[] = [];
  cartFilter: InventoryFilterDTO[] = [];
  cartFilterList: InventoryFilterDTOWithScreens[] = [];
  screens = [];
  @Input() playerCull: PlayerCullDTO;
  @Input() geoCull: GeoCullDTO;

  geoAggregation: InventoryGeoAggregationFrontendEnhancedDTO;

  ngOnInit(): void {}

  refreshMap(point?) {
    if (point) {
      this.point = point;
    }
    this.filterInventoryMap();
  }

  prepareBuildFilter(type: string, ele: { element: any; type: string }) {
    switch (type) {
      case 'cart': {
        let found: boolean;
        this.cartFilter = [];
        this.cartFilter.push(this.inventoryService.buildFilterElement(ele.element, ele.type));
        if (this.cartFilterList) {
          if (this.cartFilterList.length !== 0) {
            for (const item of this.cartFilterList) {
              for (const val of item.values) {
                if (ele.element.displayValue.id === val.displayValue.id) {
                  found = true;
                }
              }
            }
            if (found) {
              this.toaster.toast(ToastType.DANGER, this.translate.instant('lang.globals.alreadyExists'));
              // this.removeFromCart(ele);
            } else {
              this.cartFilterList.push(this.inventoryService.buildFilterElement(ele.element, ele.type));
            }
          } else {
            this.cartFilterList.push(this.inventoryService.buildFilterElement(ele.element, ele.type));
          }
        }
        this.resolveScreenIds().then((data: number[]) => {
          this.screens = this.screens.concat(data.filter(item => this.screens.indexOf(item) < 0));
          this.cartFilterList[this.cartFilterList.length - 1].screens = data;
        });

        this.calculateScreenSum();
        break;
      }
      case 'filter': {
        this.filter = [];
        this.filter.push(this.inventoryService.buildFilterElement(ele.element, ele.type));
        break;
      }
    }
  }

  calculateScreenSum() {
    const calcScreens = [];
    for (const items of this.cartFilterList) {
      if (items.screens) {
        for (const screens of items.screens) {
          calcScreens.push(screens);
        }
      }
    }
    this.screens = calcScreens;
    this.screens = this.screens.filter((val, index) => this.screens.indexOf(val) === index);
  }

  filterInventoryMap() {
    this.api
      .ds_rm_Inventory_geoAggregationFrontendEnhanced(
        99,
        {
          filters: this.filter,
          whitelistPolygons: null,
          blacklistPolygons: null,
          playerCulls: this.playerCull ? [this.playerCull] : null,
          geoCulls: this.geoCull ? [this.geoCull] : null,
          descriptorId: null,
        },
        { min: this.point.min, max: this.point.max }
      )
      .subscribe(data => {
        this.geoAggregation = data;
      });
  }

  removeFromCart(item) {
    if (item.values) {
      this.cartFilterList = this.cartFilterList.filter(el => el.values[0].value !== item.values[0].value);
    } else {
      this.cartFilterList = this.cartFilterList.filter(el => el.values[0].value !== item.value);
    }
    this.calculateScreenSum();
  }

  resolveScreenIds(): Promise<number[]> {
    return new Promise(res => {
      if (this.cartFilter && this.cartFilter.length > 0) {
        this.api
          .ds_rm_InventoryScreen_listIds({
            filters: this.cartFilter,
            whitelistPolygons: null,
            blacklistPolygons: null,
            playerCulls: null,
            geoCulls: null,
            descriptorId: null,
          })
          .subscribe(data => {
            res(data);
          });
      } else {
        res([]);
      }
    });
  }
}
